/**
 * Created by Jerker Nord on 2019-02-19.
 */

// imported this file from Thor Game for betline animations.
// modified by Pradeep Kumar

import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {TimelineLite, TimelineMax, TweenLite} from "gsap";
import {GSAPBezierSpline} from "./GSAPBezierSpline";

export class AnimatedMeshRope extends PIXI.Container {

    private _textures:PIXI.Texture[] = [];
    private _animateTimeline:TimelineLite;
    private _textureCounter:number;
    private _numberOfTextures:number = 0;
    private _winAnimation:PIXI.SimpleRope;

    private _isStatic:boolean = false;

    constructor() {
        super();

        EventHandler.addEventListener(this, BetLineEvent.HIDE_STATIC_BET_LINE, () => {
            TweenLite.killTweensOf(this._winAnimation);

            TweenLite.to(this._winAnimation, 0.1, {
                alpha : 0, onComplete : () => {
                    TweenLite.killTweensOf(this._winAnimation);

                    this._winAnimation.visible = false;
                    this._winAnimation.alpha = 1;
                    this._isStatic = false;
                }
            });
        });
    }

    /**
     * @param textures
     * @param curvePoints
     */
    public createAnimatedMeshRope(textures:PIXI.Texture[], curvePoints:number[][]):void {
        this._textures = textures;

        this._textureCounter = 0;
        this._winAnimation = new PIXI.SimpleRope(this._textures[this._textureCounter], GSAPBezierSpline.interpolate(curvePoints));
        this._winAnimation.visible = false;
        this.addChild(this._winAnimation);

        const updatePause:number = 0.01;
        this._animateTimeline = new TimelineMax({repeat : -1, paused : true});
        this._animateTimeline.add(() => this.updateTexture(), "+" + updatePause);
    }

    public getAnimatedMeshRopeTL(isStatic:boolean = false):TimelineLite {
        const animatedMeshRopeTL:TimelineLite = new TimelineLite({});

        this._isStatic = isStatic;
        this._numberOfTextures = isStatic ? 16 : this._textures.length;

        if(isStatic) {
            this._winAnimation.tint = 0xc517ea;
        } else {
            this._winAnimation.tint = 0xffffff;
        }

        animatedMeshRopeTL.add(() => (this._winAnimation.visible = true));
        animatedMeshRopeTL.add(() => (this._winAnimation.alpha = 1));
        animatedMeshRopeTL.add(() => (this._animateTimeline.restart()));
        return animatedMeshRopeTL;
    }

    public stop():void {
        this._animateTimeline.pause();
        this._animateTimeline.kill();
    }

    public getAnimatedMeshRopeTLIdle(isIdleLooping:boolean = false, isIdle:boolean = false, isCalledFromFSIntro?:boolean):void {
        // fix for #183
        if(this._isStatic) {
            this._winAnimation.tint = 0xc517ea;
        } else {
            this._winAnimation.tint = 0xffffff;
        }

        this._winAnimation.visible = true;
        this._winAnimation.alpha = 0;
        this._winAnimation.texture = this._textures[16];

        this.fadeInTl(isIdleLooping, isIdle, isCalledFromFSIntro);
    }

    private updateTexture():void {
        this._textureCounter++;
        if(this._textureCounter < this._numberOfTextures) {
            this._winAnimation.texture = this._textures[this._textureCounter];
        } else {
            this.stop();
            this._textureCounter = 0;

            if(this._isStatic) {
                this._winAnimation.texture = this._textures[16];
                this.fadeOutTl();
            } else {
                this._winAnimation.visible = false;
            }
        }
    }

    private fadeOutTl(isIdleLooping:boolean = false, isIdle:boolean = false):void {
        TweenLite.to(this._winAnimation, 27 / 30, {
            alpha : 0, onComplete : () => {
                if(isIdleLooping || !isIdle) {
                    this.fadeInTl();
                }
            }
        });
    }

    private fadeInTl(isIdleLooping:boolean = false, isIdle:boolean = false, isCalledFromFSIntro?:boolean):void {
        TweenLite.to(this._winAnimation, 27 / 30, {
            alpha : 1, onComplete : () => {
                if(!isCalledFromFSIntro) {
                    this.fadeOutTl(isIdleLooping, isIdle);
                }
            }
        });
    }
}